import { render, staticRenderFns } from "./SupportFeedbackLayout.vue?vue&type=template&id=32b03584&scoped=true&"
import script from "./SupportFeedbackLayout.vue?vue&type=script&lang=js&"
export * from "./SupportFeedbackLayout.vue?vue&type=script&lang=js&"
import style0 from "./SupportFeedbackLayout.vue?vue&type=style&index=0&id=32b03584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b03584",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
